export default "__VITE_ASSET__fBVczfu4__"